// extracted by mini-css-extract-plugin
export default {"item-container":"item-container__36GEZ","hasIcon":"hasIcon__1IiND","icon":"icon__fhsX-","content":"content__1PNLa"};